<script>
    import MemberEdit from "./MemberEdit.svelte";
    import MemberAdd from "./MemberAdd.svelte";
    import members from './stores/MemberStore.js';
    export let app;
    let searchInput;
    let isLoadingSearch;
    const findMember = async (appId, keywords) => {
      isLoadingSearch = true;
      await members.getAll(appId, keywords); 
      isLoadingSearch = false;
    }
    const clearSearch = () => { searchInput.value = ""; findMember(app._id, searchInput.value);}
</script>

<div class="field has-addons" >
    <div class="control is-expanded" class:is-loading={isLoadingSearch}>
      <input class="input" type="text" placeholder="Find Member" bind:this={searchInput}>
    </div>
    <div class="control">
      <!-- svelte-ignore a11y-missing-attribute -->
      <a class="button" on:click={clearSearch} on:keydown={() => {}}>X</a>
    </div>
    <div class="control">
      <button class="button is-info" on:click={() => findMember(app._id, searchInput.value)}>
        Find
      </button>
    </div>
</div>

<div class="mt-6 mb-6">
  <!-- svelte-ignore a11y-missing-attribute -->
  <p class="is-size-7">Add member</p>
  <MemberAdd {app}/>
</div>

<p class="is-size-7 mb-4 has-text-right">Viewing {$members.length} member(s) </p>
{#await members.getAll(app._id)}
  <!-- fetching members -->
{:then}  
  {#each $members as member (member.user) }
  <MemberEdit {member} {app}/>
  {/each}
{/await}


  


